import { post } from '@/utilitys/gecAxios'
export default {
  name: 'signStatus',
  data () {
    return {
      spinShow: true,
      currentUser: '',
      isLogin: false // localStorage.userinfo ? true : false,
    }
  },
  mounted () {
    this.getUserInfo()
  },
  methods: {
    register () {
      // 去注册
      location.href = 'https://sso.gecacademy.cn/register'
    },
    login () {
      // 去登录
      location.href = 'https://sso.gecacademy.cn/login'
    },
    async logout () {
      // 登出

      let { data: res } = await post(
        `/login/logout`,
        {
          // productId: ID
        })
      if (res.error.returnCode !== 0) return this.$Message.error('登出失败!')
      const DATA = res.data
      console.log(DATA)
      this.currentUser = ''
      this.isLogin = false
    },
    jumpLink (url) {
      location.href = `https://${url}`
    },
    async getUserInfo () {
      let { data: res } = await post(
        `/login/check`,
        {
          // productId: ID
        })
      if (res.error.returnCode === 0) {
        const DATA = res.data
        this.currentUser = DATA.phone
        this.isLogin = true
        this.spinShow = false
      } else {
        this.isLogin = false
        this.spinShow = false
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/signStatus/signStatus.js